<section class="tracking-references" aria-labelledby="tracking-references-heading">
  <div class="tracking-references__header">
    <puro-typography
      id="tracking-references-heading"
      class="tracking-references__title"
      variant="h5-semibold"
      component="h3"
    >
      {{ 'createShipment.packageStep.tracking.title' | translate }}
    </puro-typography>
    <span class="visually-hidden" id="tracking-references-tooltip-desc">{{
      'createShipment.packageStep.tracking.tooltip' | translate
    }}</span>
    <puro-tooltip
      #trackingTooltip
      [content]="'createShipment.packageStep.tracking.tooltip' | translate"
    >
      <button
        type="button"
        class="tracking-references__tooltip-trigger"
        [attr.aria-label]="'createShipment.packageStep.tracking.tooltipAria' | translate"
        aria-describedby="tracking-references-tooltip-desc"
        (click)="$event.preventDefault(); $event.stopPropagation()"
        (focus)="trackingTooltip.show()"
        (blur)="trackingTooltip.hide()"
      >
        <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
      </button>
    </puro-tooltip>
  </div>

  <p class="tracking-references__description">
    {{ 'createShipment.packageStep.tracking.description' | translate }}
  </p>

  @if (hasRestrictedCharactersError()) {
    <app-alert-toast
      class="tracking-references__error"
      severity="error"
      live="assertive"
      [message]="'createShipment.packageStep.tracking.restrictedCharactersError' | translate"
    />
  }

  <p class="tracking-references__note">
    <strong>{{ 'createShipment.packageStep.tracking.notePrefix' | translate }}</strong>
    {{ 'createShipment.packageStep.tracking.noteBody' | translate }}
  </p>

  <div class="tracking-references__fields">
    @for (control of trackingReferences().controls; track $index; let i = $index) {
      <div class="tracking-references__row">
        <puro-input
          class="tracking-references__input"
          [formControl]="control"
          [maxLength]="maxLength"
          [error]="hasFieldError(i)"
          [label]="
            'createShipment.packageStep.tracking.fieldLabel' | translate: { index: '' + (i + 1) }
          "
          (focusout)="onFieldBlur(i)"
        />
      </div>
    }
  </div>
</section>
